import { Sparkles } from 'lucide-react'
import Button from '../ui/Button.jsx'

const SAMPLE_URL = '/samples/egypt-test.pdf'

export default function SampleBookButton({ onLoad, loading }) {
  return (
    <Button variant="ghost" size="sm" icon={Sparkles} loading={loading} onClick={() => onLoad(SAMPLE_URL)}>
      Try a sample book
    </Button>
  )
}
